import { useContext } from "react";
import "./ChatLine.css";
import { ChatContext } from "../../context/ChatContext";

export default function ChatLine({ line, chatUserList }) {
  const { currentUser } = useContext(ChatContext);
  const isMe = line.uid === currentUser?.uid;

  return (
    <div className={`chat-line ${isMe ? "me" : "other"}`}>
      <div className={`chat-bubble ${isMe ? "me" : "other"}`}>
        {line.text}
      </div>
    </div>
  );
}